module.exports = __webpack_public_path__ + "media/images/lb/004-497bdf9b7257b9b9dff470710330f9a2.svg";